import PropTypes from 'soteria-base/src/_util/vue-types';
export const Store = PropTypes.shape({
  setState: PropTypes.func,
  getState: PropTypes.func,
  subscribe: PropTypes.func,
}).loose;

import create from 'soteria-base/src/_util/store/create';
const createStore = create;

export default createStore;
